import { css } from '@emotion/react';
import { CreatePaymentIntentBody } from '@frontend/api-weave-pay';
import { formatCentsToCurrency } from '@frontend/currency';
import { useTranslation } from '@frontend/i18n';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { ConfirmationModal, Text, ModalControlModalProps } from '@frontend/design-system';

export const styles = {
  confirmContainer: css`
    display: flex;
    flex-flow: column;
    font-weight: ${theme.font.weight.semibold};
    margin: ${theme.spacing(2, 0, 3)};
    gap: ${theme.spacing(2)};
    p {
      margin: 0;
    }

    @media (min-width: ${breakpoints.xsmall.max}px) {
      display: grid;
      grid-template-columns: repeat(2, minmax(auto, 1fr));
    }
  `,
};

interface UsePortalConfirmationModalProps extends ModalControlModalProps {
  onConfirm: () => void;
  payment: CreatePaymentIntentBody;
}

export const PaymentConfirmationModal = ({ onConfirm, payment, ...modalProps }: UsePortalConfirmationModalProps) => {
  const { t } = useTranslation('weave-pay');

  return (
    <ConfirmationModal
      {...modalProps}
      title={t('Confirm Payment')}
      onConfirm={onConfirm}
      cancelLabel={t('Continue Editing')}
      confirmLabel={t('Submit Payment')}
      maxWidth={500}
    >
      <div css={styles.confirmContainer}>
        <Text weight={'bold'}>{t('Payment amount')}</Text>
        <Text>{formatCentsToCurrency(payment?.amount || 0)}</Text>
        <Text weight={'bold'}>{t(`Patient's Name`)}</Text>
        <Text>{`${payment.person?.firstName} ${payment.person?.lastName}`}</Text>
        <Text weight={'bold'}>{t('Email')}</Text>
        <Text>{payment.person?.email || t('Not provided')}</Text>
      </div>
    </ConfirmationModal>
  );
};
